import React from 'react';

const Auth = () => {
  return <div className="auth">Auth</div>;
};

export default Auth;
